import {
    IDeviceInformation, IDeviceItemGrouping, IDeviceItemVisitor, IDeviceNode,
    IDynamicCalendar, IDynamicControlsSharedState
} from '../shared/models/device';

import { DeviceService } from '../shared/services/device.service';
import { ElementTypes } from '../shared/models/models';

export class DynamicCalendarVisitor implements IDeviceItemVisitor {
    public service: DeviceService;
    public currentGrouping: IDeviceItemGrouping;
    private rootNode: IDeviceNode;
    private sharedState: IDynamicControlsSharedState;

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        this.sharedState = sharedState;
        this.rootNode = rootNode;
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode) {
        return propValue.elementType === ElementTypes.DynamicCalendar;
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let calendar: IDynamicCalendar =  propValue as IDynamicCalendar;

        this.currentGrouping.$controlInputs.push(calendar);

        calendar.$ignoreChildren = true;
        calendar.$isContainer = true;
        calendar.$inputType = 'dynamicCalendar';
        calendar.$fieldName = this.sharedState.nextId();
        calendar.$categories = [];
        calendar.$sections = [];
        calendar.$controlInputs = [];

        this.rootNode.$flatDynamicCalendars.push(calendar);

        return calendar;
    }
}
